import {
  postEmployeeEmail,
  postEmployeeLogin,
  postEmployeeRegister,
  postEmployeeVerifyOtp,
} from '../services/authservices';
import { EmployeeLogin, EmployeeRegister, Login, Otp } from '../constant/serviceType';
import { NavigateFunction } from 'react-router-dom';

export const employeeEmail = async (payload: EmployeeLogin, navigate: NavigateFunction) => {
  let userResponse = null;
  try {
    const response = await postEmployeeEmail(payload);
    console.log('registerUser', response);
    userResponse = response?.data?.data;
    if (userResponse) {
      console.log(navigate);
      const accessToken = 'verified';
      return { success: true, data: accessToken, user: payload, id: response?.data?.data.id };
    }
  } catch (e: any) {
    return { success: false, error: e.response.data.message };
  }

  return userResponse;
};

export const verifyEmployeeOtp = async (payload: Otp, navigate: NavigateFunction) => {
  let userResponse = null;
  try {
    const response = await postEmployeeVerifyOtp(payload);
    // console.log('registerUser', response);
    userResponse = response?.data?.data;
    if (userResponse) {
      console.log(navigate);
      return { success: true, user: payload };
    }
  } catch (e: any) {
    // console.log(e.response.data.message);
    return { success: false, error: e.response.data.message };
  }

  return userResponse;
};

export const registerEmployee = async (payload: EmployeeRegister, navigate: NavigateFunction) => {
  let userResponse = null;

  try {
    const response = await postEmployeeRegister(payload);
    console.log('registerUser', response);
    userResponse = response?.data?.data.user;
    if (userResponse) {
      navigate('/app/dashboard');
      return { success: true, user: userResponse };
    }
  } catch (e: any) {
    // setError(e.response.data.errors);
    const allErrors = e.response?.data?.errors;
    const firstError = allErrors ? Object.values(allErrors).find(error => error) : e.response.data.message;
    console.log('kddmmk', e.response.data.errors.email || e.response.data.errors.phone || e.response.data.errors.password );
    console.log('kddk', allErrors);
    return { success: false, error: firstError };
  }

  return userResponse;
};

export const loginEmployee = async (payload: Login, navigate: NavigateFunction) => {
  let userResponse = null;
  try {
    const response = await postEmployeeLogin(payload);
    console.log('registerUser', response);
    userResponse = response?.data?.data;
    if (userResponse) {
      console.log(navigate);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const access_token = 'verified';
      navigate('/app/dashboard');
      return { success: true, data: access_token, user: userResponse };
    }
  } catch (e: any) {
    // console.log(e.response.data.message);
    return { success: false, error: e.response.data.message };
  }

  return userResponse;
};


